import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { onUnexpectedExternalError, canceled, isPromiseCanceledError } from '../../../base/common/errors.js';
import { registerDefaultLanguageCommand } from '../../browser/editorExtensions.js';
import * as modes from '../../common/modes.js';
import { Position } from '../../common/core/position.js';
import { RawContextKey } from '../../../platform/contextkey/common/contextkey.js';
import { CancellationToken } from '../../../base/common/cancellation.js';
import { Range } from '../../common/core/range.js';
import { FuzzyScore } from '../../../base/common/filters.js';
import { isDisposable, DisposableStore } from '../../../base/common/lifecycle.js';
import { MenuId } from '../../../platform/actions/common/actions.js';
import { SnippetParser } from '../snippet/snippetParser.js';
export var Context = {
  Visible: new RawContextKey('suggestWidgetVisible', false),
  DetailsVisible: new RawContextKey('suggestWidgetDetailsVisible', false),
  MultipleSuggestions: new RawContextKey('suggestWidgetMultipleSuggestions', false),
  MakesTextEdit: new RawContextKey('suggestionMakesTextEdit', true),
  AcceptSuggestionsOnEnter: new RawContextKey('acceptSuggestionOnEnter', true),
  HasInsertAndReplaceRange: new RawContextKey('suggestionHasInsertAndReplaceRange', false),
  CanResolve: new RawContextKey('suggestionCanResolve', false)
};
export var suggestWidgetStatusbarMenu = new MenuId('suggestWidgetStatusBar');
export var CompletionItem = /*#__PURE__*/function () {
  function CompletionItem(position, completion, container, provider) {
    _classCallCheck(this, CompletionItem);

    this.position = position;
    this.completion = completion;
    this.container = container;
    this.provider = provider; // validation

    this.isInvalid = false; // sorting, filtering

    this.score = FuzzyScore.Default;
    this.distance = 0;
    this.textLabel = typeof completion.label === 'string' ? completion.label : completion.label.name; // ensure lower-variants (perf)

    this.labelLow = this.textLabel.toLowerCase(); // validate label

    this.isInvalid = !this.textLabel;
    this.sortTextLow = completion.sortText && completion.sortText.toLowerCase();
    this.filterTextLow = completion.filterText && completion.filterText.toLowerCase(); // normalize ranges

    if (Range.isIRange(completion.range)) {
      this.editStart = new Position(completion.range.startLineNumber, completion.range.startColumn);
      this.editInsertEnd = new Position(completion.range.endLineNumber, completion.range.endColumn);
      this.editReplaceEnd = new Position(completion.range.endLineNumber, completion.range.endColumn); // validate range

      this.isInvalid = this.isInvalid || Range.spansMultipleLines(completion.range) || completion.range.startLineNumber !== position.lineNumber;
    } else {
      this.editStart = new Position(completion.range.insert.startLineNumber, completion.range.insert.startColumn);
      this.editInsertEnd = new Position(completion.range.insert.endLineNumber, completion.range.insert.endColumn);
      this.editReplaceEnd = new Position(completion.range.replace.endLineNumber, completion.range.replace.endColumn); // validate ranges

      this.isInvalid = this.isInvalid || Range.spansMultipleLines(completion.range.insert) || Range.spansMultipleLines(completion.range.replace) || completion.range.insert.startLineNumber !== position.lineNumber || completion.range.replace.startLineNumber !== position.lineNumber || completion.range.insert.startColumn !== completion.range.replace.startColumn;
    } // create the suggestion resolver


    if (typeof provider.resolveCompletionItem !== 'function') {
      this._resolveCache = Promise.resolve();
      this._isResolved = true;
    }
  } // ---- resolving


  _createClass(CompletionItem, [{
    key: "isResolved",
    get: function get() {
      return !!this._isResolved;
    }
  }, {
    key: "resolve",
    value: function resolve(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var sub;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._resolveCache) {
                  sub = token.onCancellationRequested(function () {
                    _this._resolveCache = undefined;
                    _this._isResolved = false;
                  });
                  this._resolveCache = Promise.resolve(this.provider.resolveCompletionItem(this.completion, token)).then(function (value) {
                    Object.assign(_this.completion, value);
                    _this._isResolved = true;
                    sub.dispose();
                  }, function (err) {
                    if (isPromiseCanceledError(err)) {
                      // the IPC queue will reject the request with the
                      // cancellation error -> reset cached
                      _this._resolveCache = undefined;
                      _this._isResolved = false;
                    }
                  });
                }

                return _context.abrupt("return", this._resolveCache);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return CompletionItem;
}();
export var CompletionOptions = function CompletionOptions() {
  var snippetSortOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
  var kindFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
  var providerFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();

  _classCallCheck(this, CompletionOptions);

  this.snippetSortOrder = snippetSortOrder;
  this.kindFilter = kindFilter;
  this.providerFilter = providerFilter;
};
CompletionOptions.default = new CompletionOptions();

var _snippetSuggestSupport;

export function getSnippetSuggestSupport() {
  return _snippetSuggestSupport;
}

var CompletionItemModel = function CompletionItemModel(items, needsClipboard, dispoables) {
  _classCallCheck(this, CompletionItemModel);

  this.items = items;
  this.needsClipboard = needsClipboard;
  this.dispoables = dispoables;
};

export function provideSuggestionItems(model, position) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CompletionOptions.default;
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    triggerKind: 0
    /* Invoke */

  };
  var token = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : CancellationToken.None;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _this2 = this;

    var word, defaultReplaceRange, defaultRange, result, disposables, needsClipboard, onCompletionList, snippetCompletions, _iterator2, _step2, providerGroup, lenBefore;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // const t1 = Date.now();
            position = position.clone();
            word = model.getWordAtPosition(position);
            defaultReplaceRange = word ? new Range(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn) : Range.fromPositions(position);
            defaultRange = {
              replace: defaultReplaceRange,
              insert: defaultReplaceRange.setEndPosition(position.lineNumber, position.column)
            };
            result = [];
            disposables = new DisposableStore();
            needsClipboard = false;

            onCompletionList = function onCompletionList(provider, container) {
              if (!container) {
                return;
              }

              var _iterator = _createForOfIteratorHelper(container.suggestions),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var suggestion = _step.value;

                  if (!options.kindFilter.has(suggestion.kind)) {
                    // fill in default range when missing
                    if (!suggestion.range) {
                      suggestion.range = defaultRange;
                    } // fill in default sortText when missing


                    if (!suggestion.sortText) {
                      suggestion.sortText = typeof suggestion.label === 'string' ? suggestion.label : suggestion.label.name;
                    }

                    if (!needsClipboard && suggestion.insertTextRules && suggestion.insertTextRules & 4
                    /* InsertAsSnippet */
                    ) {
                      needsClipboard = SnippetParser.guessNeedsClipboard(suggestion.insertText);
                    }

                    result.push(new CompletionItem(position, suggestion, container, provider));
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              if (isDisposable(container)) {
                disposables.add(container);
              }
            }; // ask for snippets in parallel to asking "real" providers. Only do something if configured to
            // do so - no snippet filter, no special-providers-only request


            snippetCompletions = function () {
              return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var list;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(!_snippetSuggestSupport || options.kindFilter.has(27
                        /* Snippet */
                        ))) {
                          _context2.next = 2;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 2:
                        if (!(options.providerFilter.size > 0 && !options.providerFilter.has(_snippetSuggestSupport))) {
                          _context2.next = 4;
                          break;
                        }

                        return _context2.abrupt("return");

                      case 4:
                        _context2.next = 6;
                        return _snippetSuggestSupport.provideCompletionItems(model, position, context, token);

                      case 6:
                        list = _context2.sent;
                        onCompletionList(_snippetSuggestSupport, list);

                      case 8:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
            }(); // add suggestions from contributed providers - providers are ordered in groups of
            // equal score and once a group produces a result the process stops
            // get provider groups, always add snippet suggestion provider


            _iterator2 = _createForOfIteratorHelper(modes.CompletionProviderRegistry.orderedGroups(model));
            _context4.prev = 10;

            _iterator2.s();

          case 12:
            if ((_step2 = _iterator2.n()).done) {
              _context4.next = 21;
              break;
            }

            providerGroup = _step2.value;
            // for each support in the group ask for suggestions
            lenBefore = result.length;
            _context4.next = 17;
            return Promise.all(providerGroup.map(function (provider) {
              return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var list;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(options.providerFilter.size > 0 && !options.providerFilter.has(provider))) {
                          _context3.next = 2;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 2:
                        _context3.prev = 2;
                        _context3.next = 5;
                        return provider.provideCompletionItems(model, position, context, token);

                      case 5:
                        list = _context3.sent;
                        onCompletionList(provider, list);
                        _context3.next = 12;
                        break;

                      case 9:
                        _context3.prev = 9;
                        _context3.t0 = _context3["catch"](2);
                        onUnexpectedExternalError(_context3.t0);

                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[2, 9]]);
              }));
            }));

          case 17:
            if (!(lenBefore !== result.length || token.isCancellationRequested)) {
              _context4.next = 19;
              break;
            }

            return _context4.abrupt("break", 21);

          case 19:
            _context4.next = 12;
            break;

          case 21:
            _context4.next = 26;
            break;

          case 23:
            _context4.prev = 23;
            _context4.t0 = _context4["catch"](10);

            _iterator2.e(_context4.t0);

          case 26:
            _context4.prev = 26;

            _iterator2.f();

            return _context4.finish(26);

          case 29:
            _context4.next = 31;
            return snippetCompletions;

          case 31:
            if (!token.isCancellationRequested) {
              _context4.next = 34;
              break;
            }

            disposables.dispose();
            return _context4.abrupt("return", Promise.reject(canceled()));

          case 34:
            return _context4.abrupt("return", new CompletionItemModel(result.sort(getSuggestionComparator(options.snippetSortOrder)), needsClipboard, disposables));

          case 35:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[10, 23, 26, 29]]);
  }));
}

function defaultComparator(a, b) {
  // check with 'sortText'
  if (a.sortTextLow && b.sortTextLow) {
    if (a.sortTextLow < b.sortTextLow) {
      return -1;
    } else if (a.sortTextLow > b.sortTextLow) {
      return 1;
    }
  } // check with 'label'


  if (a.completion.label < b.completion.label) {
    return -1;
  } else if (a.completion.label > b.completion.label) {
    return 1;
  } // check with 'type'


  return a.completion.kind - b.completion.kind;
}

function snippetUpComparator(a, b) {
  if (a.completion.kind !== b.completion.kind) {
    if (a.completion.kind === 27
    /* Snippet */
    ) {
      return -1;
    } else if (b.completion.kind === 27
    /* Snippet */
    ) {
      return 1;
    }
  }

  return defaultComparator(a, b);
}

function snippetDownComparator(a, b) {
  if (a.completion.kind !== b.completion.kind) {
    if (a.completion.kind === 27
    /* Snippet */
    ) {
      return 1;
    } else if (b.completion.kind === 27
    /* Snippet */
    ) {
      return -1;
    }
  }

  return defaultComparator(a, b);
}

var _snippetComparators = new Map();

_snippetComparators.set(0
/* Top */
, snippetUpComparator);

_snippetComparators.set(2
/* Bottom */
, snippetDownComparator);

_snippetComparators.set(1
/* Inline */
, defaultComparator);

export function getSuggestionComparator(snippetConfig) {
  return _snippetComparators.get(snippetConfig);
}
registerDefaultLanguageCommand('_executeCompletionItemProvider', function (model, position, args) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var result, resolving, maxItemsToResolve, completions, _iterator3, _step3, item;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            result = {
              incomplete: false,
              suggestions: []
            };
            resolving = [];
            maxItemsToResolve = args['maxItemsToResolve'] || 0;
            _context5.next = 5;
            return provideSuggestionItems(model, position);

          case 5:
            completions = _context5.sent;
            _iterator3 = _createForOfIteratorHelper(completions.items);

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                item = _step3.value;

                if (resolving.length < maxItemsToResolve) {
                  resolving.push(item.resolve(CancellationToken.None));
                }

                result.incomplete = result.incomplete || item.container.incomplete;
                result.suggestions.push(item.completion);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            _context5.prev = 8;
            _context5.next = 11;
            return Promise.all(resolving);

          case 11:
            return _context5.abrupt("return", result);

          case 12:
            _context5.prev = 12;
            setTimeout(function () {
              return completions.dispoables.dispose();
            }, 100);
            return _context5.finish(12);

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[8,, 12, 15]]);
  }));
});

var _provider = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this.onlyOnceSuggestions = [];
  }

  _createClass(_class, [{
    key: "provideCompletionItems",
    value: function provideCompletionItems() {
      var suggestions = this.onlyOnceSuggestions.slice(0);
      var result = {
        suggestions: suggestions
      };
      this.onlyOnceSuggestions.length = 0;
      return result;
    }
  }]);

  return _class;
}())();

modes.CompletionProviderRegistry.register('*', _provider);
export function showSimpleSuggestions(editor, suggestions) {
  setTimeout(function () {
    var _provider$onlyOnceSug;

    (_provider$onlyOnceSug = _provider.onlyOnceSuggestions).push.apply(_provider$onlyOnceSug, _toConsumableArray(suggestions));

    editor.getContribution('editor.contrib.suggestController').triggerSuggest(new Set().add(_provider));
  }, 0);
}